import Vue from 'vue'
import App from './App.vue'
import { createRouter } from './router' // pakai createRouter
import store from './global/store'
import vuetify from './plugins/vuetify'

import VueApexCharts from 'vue-apexcharts'
import VueGoogleCharts from 'vue-google-charts'
import HighchartsVue from 'highcharts-vue'
import Highcharts from 'highcharts'
import Highcharts3D from 'highcharts/highcharts-3d'
import HighchartsCylinder from 'highcharts/modules/cylinder'
import HighchartsAccessibility from 'highcharts/modules/accessibility'
import HighchartsMore from 'highcharts/highcharts-more'
import '@fortawesome/fontawesome-free/css/all.css'
import axios from 'axios';
import runtimeConfig from './configRuntime';

const devOrigins = [
  'http://localhost',
  'http://172.20.4.11'
];

const isDev = devOrigins.some(origin => window.location.origin.startsWith(origin));
axios.defaults.baseURL = isDev
  ? runtimeConfig.VUE_APP_API_SOCKET       // dev: port 7072 via runtimeConfig
  : window.APP_CONFIG.VUE_APP_API_SOCKET;  // production: via APP_CONFIG

const umamiSrc = window.APP_CONFIG.UMAMI_SRC || process.env.VUE_APP_UMAMI_URL; //runtimeConfig.UMAMI_SRC;
const umamiId = window.APP_CONFIG.UMAMI_ID || process.env.VUE_APP_UMAMI_ID; //runtimeConfig.UMAMI_ID;

if (umamiSrc) {
  const script = document.createElement("script");
  script.defer = true;
  script.src = umamiSrc;
  script.setAttribute(
    "data-website-id",
    umamiId
  );

  document.head.appendChild(script);
}


Vue.use(VueGoogleCharts)
Vue.use(VueApexCharts)
Vue.component('apexchart', VueApexCharts)
Vue.use(HighchartsVue)

Highcharts3D(Highcharts)
HighchartsCylinder(Highcharts)
HighchartsAccessibility(Highcharts)
HighchartsMore(Highcharts)

Vue.config.productionTip = false

function setFavicon(url) {
  if (!url) {
    console.warn("Favicon URL is not set.");
    return;
  }
  let link = document.querySelector("link[rel~='icon']");
  if (!link) {
    link = document.createElement('link');
    link.rel = 'icon';
    document.head.appendChild(link);
  }
  link.href = url;
}

async function loadTheme(themeName) {
  try {
    if (themeName == 'MedAn') {
      await import('./assets/styles/theme-variables-MedAn.css');
    } else if (themeName == 'Garuda') {
      await import('./assets/styles/theme-variables-Garuda.css');
    }
  } catch (error) {
    console.error(`Error loading ${themeName} theme:`, error);
  }
}

async function loadAssetsTheme() {
  try {
    let assetsModule;
    let themeName;

    if (process.env.VUE_APP_TITLE == "Websitemedan") {
      assetsModule = await import('@/constants/asset-logo-MedAn.js');
      themeName = 'MedAn';
    } else if (process.env.VUE_APP_TITLE == "Garuda OSINT") {
      assetsModule = await import('@/constants/asset-logo-Garuda.js');
      themeName = 'Garuda';
    }

    if (assetsModule.FAVICON_WEB) {
      setFavicon(assetsModule.FAVICON_WEB);
    }

    await loadTheme(themeName);

    Vue.prototype.$appAssets = {
      logo: assetsModule.LOGO_WEB,
      banner: assetsModule.BANNER_WEB,
      favicon: assetsModule.FAVICON_WEB,
      base64HeaderMedan: assetsModule.BASE64_HEADER_MEDAN247,
      base64HeaderSolusi: assetsModule.BASE64_HEADER_SOLUSI247
    };
    return true;
  } catch (error) {
    setFavicon('/favicon.ico');
    await loadTheme('MedAn');

    Vue.prototype.$appAssets = {
      logo: null,
      banner: null,
      favicon: '/favicon.ico',
      base64HeaderMedan: null,
      base64HeaderSolusi: null
    };

    return false;
  }
}

async function bootstrap() {
  try {
    await loadAssetsTheme();

    const router = await createRouter();

    new Vue({
      store,
      router,
      vuetify,
      render: h => h(App)
    }).$mount('#app');
  } catch (error) {
    console.error('Failed to bootstrap application:', error);

    const router = await createRouter();
    new Vue({
      store,
      router,
      vuetify,
      render: h => h(App)
    }).$mount('#app');
  }
}

bootstrap();